import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import PaymentForm from "../DeliveryBoys/PaymentForm";
import { fetchPayments } from "../DeliveryBoys/riderPaymentsData";
import { standingLine } from "../DeliveryBoys/riderReportData";
import RiderPicker from "./RiderPicker";

export default function CollectMoneyModal({ open, onClose, onSaved }) {
  const [riderId, setRiderId] = useState(undefined);
  const [standing, setStanding] = useState("");

  useEffect(() => {
    if (!open) setRiderId(undefined);
  }, [open]);

  useEffect(() => {
    let live = true;
    setStanding("");
    if (riderId) {
      fetchPayments({ riderId, limit: 1 }).then((result) => {
        if (live) setStanding(standingLine(result.summary));
      });
    }
    return () => {
      live = false;
    };
  }, [riderId]);

  return (
    <Modal open={open} title="Rider Collection" rootClassName="settlements" onCancel={onClose} footer={null} destroyOnHidden width={640}>
      <div className="stl collect-money">
        <RiderPicker value={riderId} onChange={setRiderId} />
        <p className="collect-money__standing">{riderId ? standing || "Checking what the rider holds…" : "Pick the rider who is paying."}</p>
        <PaymentForm key={riderId || "none"} riderId={riderId} onSaved={onSaved} onCancel={onClose} />
      </div>
    </Modal>
  );
}
